import script from "./Roadmap.vue?vue&type=script&setup=true&lang=js"
export * from "./Roadmap.vue?vue&type=script&setup=true&lang=js"

import "./Roadmap.vue?vue&type=style&index=0&id=656844f2&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-656844f2"]])

export default __exports__